export const ANSWER_TOOLTIP_ID = "AnswerTooltipId";
export const ANSWER_TOOLTIP_ICON_ID = "AnswerTooltipIconId";
export const ANSWER_TOOLTIP_ANSWER_ID = "AnswerTooltipAnswerId";
export const ANSWER_TOOLTIP_ANSWER_PERCENTAGE_ID =
  "AnswerTooltipAnswerPercentageId";
